import { itiHttpService, itiMessageService } from '@/iti-core-vue';
import { ItiVHeader, ItiIconButton } from '@/iti-core-vuetify';
import collaborativeAreaModule from '@/store/modules/collaborative-area.module';
import { Component, Prop, Vue } from "vue-property-decorator";
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxButton from 'devextreme-vue/button';
import DxValidationSummary from 'devextreme-vue/validation-summary';
import {
    DxValidator,
    DxRequiredRule,
} from 'devextreme-vue/validator';
import { userModule } from '@/store';
import { CollaborativeAreaMember } from '@/shared/dtos/collaborative-area-member';
import { Rol } from '@/shared/dtos/rol';
import { User } from '@/shared/dtos/user';
import { CollaborativeAreaType } from '@/shared/dtos/collaborative-area-type';

@Component({
  components: {
    ItiIconButton,
    DxSelectBox,
    DxTextBox,    
    DxTextArea,
    DxButton,
    DxValidator,
    DxRequiredRule,
    DxValidationSummary,
  }
})
export default class CollaborativeAreaForm extends Vue {

  @Prop() id !: number;  
  public loading = false;
  public search = ''; 
  public dialog = false;
  public dialogDelete = false; 
  public rolEditMode = false;
  public areaTypeName = "";
  
  public get headers() {
      return [        
          new ItiVHeader('user.completeUser', 'collaborative-area.name'),
          new ItiVHeader('user.email', 'collaborative-area.email'),
          new ItiVHeader('roleInAmbit.description', 'collaborative-area.rol'),
          new ItiVHeader('action', ''),
      ];
  }

  public get collaborativeArea() {    
    return collaborativeAreaModule.selectedCollaborativeArea;
  }

  public get collaborativeAreaTypes() {    
    return collaborativeAreaModule.collaborativeAreaTypes;
  }

  public get usersAndRoles() {   
    return collaborativeAreaModule.usersAndRolesArea;
  }

  public get areaTitle() {    
    if (collaborativeAreaModule.selectedCollaborativeArea.name == null || collaborativeAreaModule.selectedCollaborativeArea.name.length == 0) {
        return this.$t('collaborative-area.newArea');
    } else {
        return collaborativeAreaModule.selectedCollaborativeArea.name;
    }
  }

  public get areaState() {
    if (collaborativeAreaModule.selectedCollaborativeArea.active) {
      return this.$t('collaborative-area.activated');
    } else {
      return this.$t('collaborative-area.disabled');
    }
  }

  public get userRoleTitle() {
    if (this.rolEditMode) {
      return this.$t('collaborative-area.editRole');
    } else {
      return this.$t('collaborative-area.newUser');      
    }
  }

  public get areaEditMode() {
    return collaborativeAreaModule.areaEditMode;
  }

  public get collaborativeAreaMember() {
    return collaborativeAreaModule.collaborativeAreaMember;
  }

  public get collaborativeAreaRoles() {    
    return userModule.roles;
  }

  public get usersNotInArea() {
    return userModule.usersNotInArea;
  }

  public get userRoleInArea() {
    return userModule.userRoleInArea;
  }
  
  public get isOwnerRole() {
    return this.userRoleInArea.roleId == 4;
  }

  public get title() {    
      switch(this.collaborativeArea.type) {
          case 0: {                                                  
              this.areaTypeName = this.$tc('collaborative-area.publicArea') + ":";
              break;
          }
          case 1: {                                                                          
              this.areaTypeName = this.$tc('collaborative-area.workGroups') + ":";
              break;
          }
          case 2: {                                  
              this.areaTypeName = this.$tc('collaborative-area.collaborativeAreas') + ":";
              break;
          }
      }
      return this.areaTypeName;   
  }

  public created() {        
    if (!isNaN(this.id) && this.id != 0) {
      collaborativeAreaModule.getCollaborativeAreaById(this.id)
        .then( () => {          
          if (this.collaborativeArea.type == 2) {
            this.collaborativeAreaTypes.push(new CollaborativeAreaType(2, "PrivateArea")); 
          }                     
        });
      collaborativeAreaModule.getUsersAndRolesByAmbitId(this.id);
      userModule.getUsersNotInCollaborativeArea(this.id);
      userModule.getUserRoleInArea(this.id);
      collaborativeAreaModule.setAreaEditMode(true);            
    } else {      
      collaborativeAreaModule.newCollaborativeArea();
      collaborativeAreaModule.setAreaEditMode(false);            
    }
  }

  public mounted() {       
    collaborativeAreaModule.setCollaborativeAreaTypes();
    collaborativeAreaModule.fetchId();
    userModule.getCollaborativeAreaRoles();
  }

  public saveCollaborativeArea() {
    itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-guardar'), this.$tc('mensajes.confirmar'), (res) => {      
      if (res) {         
        if(!this.areaEditMode) {
          var owner: CollaborativeAreaMember = new CollaborativeAreaMember();
          owner.id = 0;
          owner.roleId = 4;
          owner.userId = collaborativeAreaModule.myId;          
          this.collaborativeArea.users.push(owner);
        }
        collaborativeAreaModule.saveCollaborativeArea(this.collaborativeArea)        
          .then(() => {
            this.savedArea();  
            this.$router.back();         
          })
          .catch(() => {
              itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
          });
      }
    });
  }

  public savedArea() {        
    collaborativeAreaModule.getCollaborativeAreaById(this.collaborativeArea.id);
    collaborativeAreaModule.getUsersAndRolesByAmbitId(this.collaborativeArea.id);
    userModule.getUsersNotInCollaborativeArea(this.collaborativeArea.id);
    userModule.getUserRoleInArea(this.collaborativeArea.id);
    collaborativeAreaModule.setAreaEditMode(true);                
    if (this.id == 0) this.$router.push({ name: 'CollaborativeAreaForm', params: { id: this.collaborativeArea.id.toString()} });                
    itiMessageService.toast(this.$tc('mensajes-plantillas.ok'), 'success', 3000);
  }

  public setNameType(collaborativeAreaType: CollaborativeAreaType) {
    if (collaborativeAreaType != null) {
      return this.$tc('types-collaborative-area.' + collaborativeAreaType.name);        
    }
  }

  public setNameUser(user: User) {    
    if (user != null) {
      if (user.completeUser == null) return this.$tc('collaborative-area.unnamedUser');
      else return user.completeUser;    
    }    
  }

  public setRoleDescription(rol: Rol) {
    if(rol != null) {
      return this.$tc('roles-collaborative-area.' + rol.name);     
    }
  }

  public areaActive(state: boolean) {        
    collaborativeAreaModule.changeStateCollaborativeArea(state)
      .then(() => {
        this.collaborativeArea.active = state;
      })
      .catch(() => {
          this.collaborativeArea.active = !state;
          itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
    });    
  }  

  public addUser() { 
    this.rolEditMode = false;   
    collaborativeAreaModule.setNewCollaborativeAreaMember();
  }

  public close() {    
    userModule.getUsersNotInCollaborativeArea(this.id);
    this.rolEditMode = false;
    this.dialog = false;    
  }

  public save() {    
    this.collaborativeAreaMember.ambitId = this.id;    
    collaborativeAreaModule.asociateUserToCollaborativeArea()
      .then(() => {
        collaborativeAreaModule.getUsersAndRolesByAmbitId(this.id);
        userModule.getUsersNotInCollaborativeArea(this.id);
        this.close();
      })
      .catch( () => {
        itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
      })    
  }

  public editItem(data: CollaborativeAreaMember) {
    this.rolEditMode = true;    
    this.usersNotInArea.push(data.user);
    this.collaborativeAreaMember.userId = data.user.id;
    this.collaborativeAreaMember.roleId = data.roleInAmbit.id;    
    this.dialog = true;
    
  }
  
  public deleteItem(data: CollaborativeAreaMember) {
    itiMessageService.confirm(this.$tc('collaborative-area.pregunta-borrar-usuario-area'), this.$tc('mensajes.confirmar'), (res) => {        
      if (res) {   
        this.collaborativeAreaMember.ambitId = this.id;
        this.collaborativeAreaMember.userId = data.user.id;  
        collaborativeAreaModule.disassociateUserToCollaborativeArea()             
        .then( () => {
          collaborativeAreaModule.getUsersAndRolesByAmbitId(this.id);
          userModule.getUsersNotInCollaborativeArea(this.id);
          itiMessageService.toast(this.$tc('mensajes-plantillas.info-eliminar'), 'success', 3000);
        })
        .catch( () => {                    
          itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
        });                         
      }
    });
  }

  public isOwner(e: any) {          
    if ((e.roleInAmbit.id == 4 && e.user.id == collaborativeAreaModule.myId) || this.userRoleInArea.roleId != 4) {
      return false;
    } else {
      return true;
    }    
  }

}
